var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.logged)?_c('left-menu',{attrs:{"menus":_vm.menus,"auto-collapse":false}}):_c('login',{attrs:{"login-url":"signin/login","domain":"Xtooltech","project":"R0ABbvpE2xe7b4y9kzEq"},on:{"success":_vm.loginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }